module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAyUlEQVR4Ae3QAUYEYRyG8R9BYIEdCKDukAVzgQUqgGCxOsV3iwB1jQJhCRZAJxhIixkEaf0jMRiN3fkWlnkfgMeD19Fu3IUXX2JHkn925kOI/NCdOEwojaEut4cKfTrPCT0qf7kX3pzmf3TiVXjID1F4F27yQ1z6bp9KIpM0hoaEKgsLVVfudTqhRgEKdTfQ4ySglCRPwhrAWniWWnqdUjtzoTEFU40wB/s6JjZCZWmpEjYmgxxc2Yo/tq4NdTCzUqutzGQ4x7JxP5hfSPvH8BckAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/map/images/transportation.png
// module id = 1172
// module chunks = 0